<template>
  <svg width="16" height="16" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1794 1.32913C12.4304 1.46908 12.5536 1.76219 12.478 2.03947L10.8183 8.12502H16.875C17.1239 8.12502 17.349 8.27267 17.4482 8.50093C17.5474 8.72918 17.5017 8.99453 17.3319 9.17647L8.58192 18.5515C8.38582 18.7616 8.0717 18.8109 7.82067 18.6709C7.56964 18.531 7.44641 18.2379 7.52204 17.9606L9.18173 11.875H3.12501C2.87614 11.875 2.65098 11.7274 2.5518 11.4991C2.45261 11.2709 2.49829 11.0055 2.6681 10.8236L11.4181 1.44857C11.6142 1.23846 11.9283 1.18917 12.1794 1.32913Z"
      fill="white"
    />
  </svg>
</template>
